import { createStore } from 'zustand'

import { PaperFormat, PaperFormatValueMap } from '../../enums/PaperFormat'
import { PaperMarginType } from '../../enums/PaperMarginType'

import { ContractDesignerEditorStore } from './interface'

export const createContractDesignerEditorStore = () =>
  createStore<ContractDesignerEditorStore>()((set, get) => ({
    paperSpec: {
      format: PaperFormat.A4,
      width: PaperFormatValueMap[PaperFormat.A4].width,
      height: PaperFormatValueMap[PaperFormat.A4].height
    },
    setPaperSpec(paperSpec) {
      set({ paperSpec })
    },
    paperMarginType: PaperMarginType.NARROW,
    setPaperMarginType(paperMarginType) {
      set({ paperMarginType })
    }
  }))
